import React from "react";
import { Box, Stack, Typography, Avatar } from "@mui/material";
import { connect } from "react-redux";
import { setUserlistShow } from "../../../../Redux/Actions/actions";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    internalChatData: contactListData.internalChatData,
  };
};

const InternalConversationHeader = (props) => {
  const agentId = JSON.parse(localStorage.getItem("tokenAgent"));

  return (
    <Box
      sx={{
        height: "max-content",
        width: "100%",
        backgroundColor: "white",
        borderRadius: "0 7px 0 0",
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        zIndex: "999 !important",
      }}
      p={1}
    >
      <Stack
        alignItems={"center"}
        direction={"row"}
        justifyContent={"space-between"}
        sx={{ width: "100%" }}
      >
        <Stack direction={"row"} sx={{ width: "100%" }}>
          <Stack direction={"row"} spacing={1} sx={{ flexGrow: 1 }}>
            <Avatar
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                background: "#0B3363",
              }}
              className="box-inset2"
            >
              {props.internalChatData
                ? props.internalChatData.reciverDetails
                  ? props.internalChatData.reciverDetails[0]._id !== agentId.id
                    ? props.internalChatData.reciverDetails[0].username
                        .slice(0, 2)
                        .toUpperCase()
                    : props.internalChatData.senderDetails[0].username
                        .slice(0, 2)
                        .toUpperCase()
                  : props.internalChatData.username.slice(0, 2).toUpperCase()
                : ""}
            </Avatar>
            <Stack
              spacing={0.1}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, fontSize: "13px" }}
              >
                {props.internalChatData
                  ? props.internalChatData.reciverDetails
                    ? props.internalChatData.reciverDetails[0]._id !==
                      agentId.id
                      ? props.internalChatData.reciverDetails[0].username
                      : props.internalChatData.senderDetails[0].username
                    : props.internalChatData.username
                  : ""}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default connect(mapStateToProps, { setUserlistShow })(
  InternalConversationHeader
);
